import moment from 'moment'

export default {
  computed: {
    $nowYear() {
      return moment(new Date().toISOString())
        .locale('th')
        .add(543, 'Y')
        .format('YYYY')
    },
    $nowBudgetYear() {
      const month = new Date().getMonth()
      return moment(new Date().toISOString())
        .locale('th')
        .add(month > 8 ? 544 : 543, 'Y')
        .format('YYYY')
    }
  },

  methods: {
    $dateFormat(date, payload = {}, baseformat = null) {
      const {
        format = 'YYYY-MM-DD',
        addValue = 0,
        addUnit = 'y',
        locale = 'th'
      } = payload

      if (!date) return ''

      return moment(date, baseformat)
        .locale(locale)
        .add(addValue, addUnit)
        .format(format)
    },

    $dateFormatByLang(date, payload = {}) {
      const { format = 'DD MMMM YYYY' } = payload

      if (!date) return ''
      const res =
        this.$lang === 'Tha'
          ? moment(date)
              .locale('th')
              .format(format)
          : moment(date)
              .locale('en')
              .format(format)
      if (this.$lang === 'Tha') {
        const stringSplit = res.split(' ')
        const year = parseInt(stringSplit[2]) + 543
        this.res = stringSplit[0] + ' ' + stringSplit[1] + ' ' + year.toString()
        return this.res
      }

      return res
    },

    $dateDiff(startDate, endDate, counterUnit = 'days') {
      if (!startDate || !endDate) return 0
      return moment(startDate).diff(moment(endDate), counterUnit)
    }
  }
}
